import React from "react";
import {Controlled as CodeMirror} from 'react-codemirror2';
import actions from "fantastic/actions";
import connectActions from "fantastic/lib/connectActions";

const Html = ({ node, edit }) => {
  const options = {
    theme: 'monokai',
    mode: 'htmlmixed',
    lineNumbers: true,
    lineWrapping: false,
    styleActiveLine: false,
    readOnly: "nocursor",
    autoCursor: false
  }
  return (
    <div className="ftc-settingable-html">
      <label>{ i18n.t('html_content') }</label>
      <div className="ftc-settingable-html__code">
        <CodeMirror
          value={node.contents.slice(0,512)}
          options={options}
          onMouseDown={(editor, event) => event.preventDefault() }
        />
      </div>
      <div>
        <button className="btn btn-default btn-around" onClick={() => edit(node.id)}>
          <i className="fi fi-edit" />
          <span>{ i18n.t('html_open_editor') }</span>
        </button>
      </div>
    </div>
  );
};

export default connectActions({ edit: actions.editId })(Html);
